module.exports = __webpack_public_path__ + "images/emoji/customs.576cdf29f01f7a412f09.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/customs.png
// module id = W3rf
// module chunks = 24